import {
  bustJobpostsCache, bustSuperActivitiesCache,
  bustKnowledgeResourcesCache, bustPsGuidanceCache, bustChallengeQuestionsCache, // ADD
  bustAllJobpostsCache, bustStarTemplatesGlobal, bustInterviewQuestionsGlobal,
} from './dashboardDb';

const CACHE_VERSION_KEY = 'content_cache_version';
const CONTENT_CACHE_VERSION = 'v6'; // bump this string whenever CMS content shape changes

// ADD this line — module-level, outside the function, so it persists across calls
let inFlightBust = null;

export const ensureFreshCacheVersion = async () => {
  const storedVersion = localStorage.getItem(CACHE_VERSION_KEY);
  if (storedVersion === CONTENT_CACHE_VERSION) return;

  if (inFlightBust) return inFlightBust;

  inFlightBust = (async () => {
    try {
      localStorage.setItem(CACHE_VERSION_KEY, CONTENT_CACHE_VERSION);

      const prefixesToBust = [
        'knowledge_resources_all_',
        'team_challenge_questions_',
        'ps_guidance_sets_',
        'all_jobposts_',
        'star_templates_global',
        'top_interview_questions_global',
        'ai_skills_cache_',
        'free_courses_cache_',
        'investor_deck_sections_cache',
        'xperience_stageinfo_',
        'coach_facet_descriptions',
        'coach_skills_cache',
        'learning_resources_cache',
        'coachfeed_categories',
      ];

      Object.keys(localStorage).forEach((key) => {
        if (prefixesToBust.some((prefix) => key.startsWith(prefix))) {
          localStorage.removeItem(key);
        }
      });

      await Promise.all([
        bustJobpostsCache(),
        bustSuperActivitiesCache(),
        bustKnowledgeResourcesCache(),
        bustPsGuidanceCache(),
        bustChallengeQuestionsCache(),
        bustAllJobpostsCache(),
        bustStarTemplatesGlobal(),
        bustInterviewQuestionsGlobal(),
      ]);

      console.log(`Content cache busted for version ${CONTENT_CACHE_VERSION}`);
    } catch (err) {
      console.warn('Cache version check failed:', err);
    } finally {
      inFlightBust = null;
    }
  })();

  return inFlightBust;
};